import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function LoadingState({ message, fullScreen = false, size = 28 }) {
  const { t } = useTranslation('common');
  const displayMessage = message ?? t('loading');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        minHeight: fullScreen ? '100vh' : 120,
        py: fullScreen ? 0 : 4,
      }}
    >
      <CircularProgress size={size} />
      {displayMessage && (
        <Typography variant="body2" color="text.secondary">
          {displayMessage}
        </Typography>
      )}
    </Box>
  );
}
